export default __webpack_public_path__ + "static/media/photo--lg--kickoff3.632f07d3.jpg";